import React from "react";


const CheckoutStep = ({ step }) => {
	var T = window.Texts.checkout;
	return (
		<div className="checkout-steps">
			<ul>
				<li>
					{T.titleShippingPayment}
				</li>
				<li className="arrows">
					{T.yourData}
				</li>
				<li>
					{T.summary}
				</li>
			</ul>
		</div>
	);
};
export default CheckoutStep;